export default "wbgdrb.applythrunet.co.in\n";